import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../components/useAuth.js";
import "./Login.css";

const Login = () => {
  const navigate = useNavigate();
  //const location = useLocatin();
  const { login } = useAuth();

  const [username, setUsername] = useState("");
  const [userpass, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const auth_url = "https://api.ope-note.jp/admin/auth.php";
      const response = await fetch(auth_url, {
        method: "POST",
        mode:"cors",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: username, userpass: userpass, mode: 'auth' }),
      });

      const data = await response.json();
      console.log(data);
      if (response.ok && data.user?.token) {
        login(data.user.token, data.user.category, data.user.su_flag);
        navigate("/");
      } else {
        setError("アカウントかパスワードが違います");
      }
    } catch (err) {
      console.error(err);
      setError("通信エラーです");
    }
  };

  return (
    <div className="Login">
      <div className="Login-Title"><label>管理画面ログイン</label></div>
      <div className="Login-header">
        <div>{error}</div>
        <form className="Login-form" onSubmit={handleLogin}>
          <label>
            アカウント
            <input
              type="text"
              name="username"
              id="username"
              value={username}
              required
              onChange={(event) => setUsername(event.target.value)}
            />
          </label>
          <label>
            パスワード
            <input
              type="password"
              name="userpass"
              id="userpass"
              value={userpass}
              required
              onChange={(event) => setPassword(event.target.value)}
            />
          </label>
          <div>
            <button type="submit" id="auth_btn" className="Login-Btn">
              認証する
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
